/**
 * WEB-2310 — единственное место, где кабинет пишет формы вызова библиотеки
 * подключения приложения. Отсюда собирают сниппет словарь (обе половины,
 * `acDevSnippetIos` / `acDevSnippetAndroid` / `acDevSnippetServer`) и окно
 * «Показать код» на вкладке «Основное» (`main/ConnectionSection.tsx`).
 *
 * Сигнатуры — по исходникам библиотек (iOS 0.7.1/0.8.1, Android
 * 0.7.1/0.7.2): iOS — модуль `Web2AppSDK`, `configure(projectId: String,
 * baseUrl: URL)`; Android — `configure(context: Context, projectId: String,
 * baseUrl: String)`. Совпадение со справочником ИИ-помощников и страницей
 * быстрого старта держит сторож `sdkSnippetForms.test.ts`.
 */

/** Строка импорта iOS. Модуль библиотеки — `Web2AppSDK`, не `Web2App`. */
export const SDK_IOS_IMPORT_LINE = 'import Web2AppSDK';

/** iOS: адрес API — `URL`, строку библиотека не принимает. */
export function sdkIosConfigureCall(projectId: string, apiBase: string): string {
  return `Web2App.configure(projectId: "${projectId}", baseUrl: URL(string: "${apiBase}")!)`;
}

/** Android: первым аргументом обязателен `context`. */
export function sdkAndroidConfigureCall(projectId: string, apiBase: string): string {
  return `Web2AppSdk.configure(context, "${projectId}", "${apiBase}")`;
}

/**
 * Идентификатор посетителя в примере серверного запроса. Сервер принимает
 * от 8 до 64 знаков алфавита `A-Za-z0-9_-` (public-guid.grammar.ts); прежний
 * `usr_4kT` (7 знаков) получал отказ проверки запроса.
 */
export const SDK_SERVER_SNIPPET_GUID = 'usr_4kT9xQ2m';
